import {atom, DefaultValue, selectorFamily} from "recoil";
import {FormSearchRateModel, RateAccordionsExpanded, RateEntityResponse, RateSelectFE} from "../api/types/rate";
import {RentalPeriodEntityResponse} from "../api/types/rentalPeriods";

export const rateSelectListAtom = atom<RateSelectFE[]>({
    key: "rateSelectListAtom",
    default: []
});

export const rentalPeriodsAbsoluteListAtom = atom<RentalPeriodEntityResponse[]>({
    key: "rentalPeriodsAbsoluteListAtom",
    default: []
});

export const rateListAtom = atom<RateEntityResponse[]>({
    key: "rateListAtom",
    default: []
});

export const initialRateFilters: FormSearchRateModel = {
    id: "",
    name: "",
    commercialCategoryId: null,
    commercialSegmentId: null,
    tpUnit: "",
    pickupDateFrom: "",
    pickupDateTo: "",
    reservationFrom: "",
    reservationTo: "",
    active: false,
    dealers: [],
    legalEntities: []
};
export const rateFiltersAtom = atom<FormSearchRateModel>({
    key: "rateFiltersAtom",
    default: initialRateFilters
});

export const rateAccordionsExpandedState = atom<RateAccordionsExpanded>({
    key: "rateAccordionsExpandedState",
    default: {
        otherDefinition: false,
        referenceTariff: false,
        advancedBooking: false
    }
});

export const rateAccordionExpandedState = selectorFamily<boolean, keyof RateAccordionsExpanded>({
    key: "rateAccordionExpandedState",
    get: accordionName => ({get}) => get(rateAccordionsExpandedState)[accordionName],
    set: accordionName => ({get, set}, newValue) => {
        set(rateAccordionsExpandedState, {
            ...get(rateAccordionsExpandedState),
            [accordionName]: newValue instanceof DefaultValue ? false : newValue
        });
    }
});